export const colors = {
  white: '#ffffff',
  black: '#000000',
  blueLight: '#f1f6f9',
  blueDark: '#14274e',
  grayDark: '#394867',
  greyLight: '#9ba4b4',
}
